<template lang="pug">
  section.partner
    h1(:class="titleAnimation") 合作伙伴
    h2 COOPERATIVE PARTNER
    div
      div(v-for="(item, index) in partner" :class="[contentAnimation, `animateDelay-${index}`]")
        img(:src="item.img")
        span {{ item.text }}
</template>

<script>
  // 链上海南
  const linkHiNan = 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E7%85%A7%E7%89%87/%E9%98%BF%E5%B0%94%E6%B3%95%E4%B8%8E%E2%80%9C%E9%93%BE%E4%B8%8A%E6%B5%B7%E5%8D%97%E2%80%9D%E6%88%98%E7%95%A5%E5%90%88%E4%BD%9C.png';
  // 城市安全大脑
  const securityMind = 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E7%85%A7%E7%89%87/%E9%87%8D%E5%BA%86%E5%9F%8E%E5%B8%82%E5%AE%89%E5%85%A8%E5%A4%A7%E8%84%91.png';
  // 微看合作
  const weCare = 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E7%85%A7%E7%89%87/%E9%98%BF%E5%B0%94%E6%B3%95%E4%B8%8E%E5%BE%AE%E7%9C%8B%E5%AE%9D%E5%AE%9D%E3%80%81%E8%85%BE%E8%AE%AF%E6%99%BA%E6%85%A7%E6%95%99%E8%82%B2%E5%90%88%E4%BD%9C.png';
  
  import Mixin from "../../index";
  export default {
    name: "partner",
    mixins: [Mixin],
    data() {
      return {
        partner: [
          {img: linkHiNan, text: '阿尔法与“链上海南”战略合作'},
          {img: securityMind, text: '重庆城市安全大脑'},
          {img: weCare, text: '阿尔法与微看宝宝、腾讯智慧教育合作'},
        ],
      };
    },
  };
</script>

<style scoped lang="stylus">
  @import "../../index.styl"
  .partner {
    padding 100px 0
    max-width 100%
    VStack(center)
    > div {
      HStack(center, center)
      max-width 100%
      > div {
        max-width 33.33%
        VStack()
        margin 20px
        img {
          max-width 100%
        }
        > span {
          margin-top 14px
          FontSetting("思源黑体 CN Regular")
        }
      }
    }
  
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      width 100vw
      > div {
        width 100vw
      }
    }
    @media (max-width screenWidth) {
      padding 50px 0
      > div {
        HStack()
        width 100%
        overflow-x auto
        > div {
          flex-shrink 0
          width calc(60%)
          max-width 100%
          > img {
            width 100%
          }
        }
      }
    }
  }
</style>
